module.exports = __webpack_public_path__ + "baby-girl-floral.png";